import { FC } from 'react';

import TourAutoComplate, { TourTypes } from '@domain/tour/tourAutoComplate';

import { Wrapper } from './styled';

type PropTypes = {
  onChange?: (data: TourTypes) => void;
  isSubmit: boolean;
  resetIsSubmit: () => void;
};

const TourSelection: FC<PropTypes> = ({
  onChange: pOnChange = (v) => v,
  isSubmit,
  resetIsSubmit,
}) => {
  return (
    <Wrapper>
      <TourAutoComplate
        label='Tur Adı'
        onChange={(v) => pOnChange(v)}
        isSubmit={isSubmit}
        resetIsSubmit={resetIsSubmit}
      />
    </Wrapper>
  );
};
export default TourSelection;
